"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alvito": {
    "7dd6468b": [{
      "hkey": "2e7fea85",
      "slug": "sant-onofrio",
      "name": "Sant'Onofrio",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "2e7fea85",
      "slug": "sant-onofrio",
      "name": "Sant'Onofrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "alvito"
    }]
  }
};
exports["default"] = _default;